import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuctionService } from '@services/auction/auction.service';

@Component({
  selector: 'app-live-auction',
  templateUrl: './live-auction.component.html',
  styleUrls: ['./live-auction.component.scss'],
})
export class LiveAuctionComponent implements OnInit {
  public loading: boolean = false;
  public individualAuctionItems = {
    present: [],
  };

  constructor(
    public auctionService: AuctionService,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // this.getAuctionAllList();
  }

  ngOnDestroy() {
    this.individualAuctionItems.present = [];
  }

  getAuctionAllList() {
    this.getIndividualAuction();
    this.getBatchAuctionList();
    this.getGroupAuctionList();
  }

  getIndividualAuction = () => {
    this.loading = true;
    this.auctionService.getIndividualAuction().subscribe(
      (res) => {
        this.loading = false;

        if (res['success']) {
          this.individualAuctionItems =
            this.auctionService.getAuctionModifyData(res['data']);
        }
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
      }
    );
  };

  getBatchAuctionList = () => {
    this.auctionService.getBatchAuctionList().subscribe((res) => {
      if (res['success']) {
        this.individualAuctionItems = this.auctionService.getAuctionModifyData(
          res['data']
        );
      }
    });
  };

  getGroupAuctionList = () => {
    this.auctionService.getGroupAuctionList().subscribe((res) => {
      if (res['success']) {
        this.individualAuctionItems = this.auctionService.getAuctionModifyData(
          res['data']
        );
      }
    });
  };

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
